import { render, staticRenderFns } from "./UserPageHeader.vue?vue&type=template&id=379fa2e1"
import script from "./UserPageHeader.vue?vue&type=script&lang=js"
export * from "./UserPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports